import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class MilitaryShipyardBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MILITARY_SHIPYARD;
}

export default MilitaryShipyardBuildingTileEntity;
